import is from 'typescript-styled-is'
import styled from '../../../theme'

const Image = styled.img<IImageProps>`
  color: transparent;

  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;

  ${is('w')`
    width: ${({ w }: IImageProps) => w}px;
  `}
  ${is('h')`
    height: ${({ h }: IImageProps) => h}px;
  `}
  ${is('onClick')`
    &:hover {
      cursor: pointer;
    }
  `}
`

export default Image

export interface IImageProps {
  w?: number
  h?: number
  onClick?: () => void
}
